import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import JobTimeline from "@/components/JobTimeline";
import { Plus, Package, ArrowRight } from "@phosphor-icons/react";

export default function CustomerDashboard() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("active");

  useEffect(() => {
    api.get("/jobs").then((r) => setJobs(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = jobs.filter((j) => tab === "active" ? j.phase !== "Completed" : j.phase === "Completed");

  return (
    <Layout>
      <div className="max-w-[1400px] mx-auto px-6 py-10">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
          <div>
            <div className="chip mb-3">// your projects</div>
            <h1 className="font-display text-5xl md:text-6xl">Dashboard</h1>
          </div>
          <Link to="/request-quote" data-testid="new-request-btn" className="btn-primary inline-flex items-center gap-2 px-5 py-3">
            <Plus size={18} weight="bold" /> New Request
          </Link>
        </div>

        <div className="flex gap-2 border-b-2 border-[var(--gc-navy)] mb-6">
          {["active", "completed"].map((t) => (
            <button key={t} onClick={() => setTab(t)}
              className={`px-4 py-3 text-sm capitalize font-semibold transition-colors -mb-[2px] ${tab === t ? 'bg-[var(--gc-navy)] text-white' : 'text-[var(--gc-navy)] hover:bg-[var(--gc-bg-alt)]'}`}
              data-testid={`tab-${t}`}>
              {t} Jobs
            </button>
          ))}
        </div>

        {loading ? (
          <div className="text-center py-20 tech-label">LOADING…</div>
        ) : filtered.length === 0 ? (
          <div className="sticker p-16 text-center">
            <Package size={40} className="mx-auto text-[var(--gc-orange)]" weight="bold" />
            <div className="font-display text-3xl mt-4">No {tab} jobs yet</div>
            <p className="text-[var(--gc-text-muted)] mt-2">{tab === "active" ? "Start your first project by requesting a quote." : "Completed jobs will appear here."}</p>
            {tab === "active" && (
              <Link to="/request-quote" className="btn-primary inline-flex items-center gap-2 mt-6 px-5 py-3" data-testid="empty-new-request">
                Request a Quote <ArrowRight size={16} weight="bold"/>
              </Link>
            )}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {filtered.map((j) => (
              <Link to={`/jobs/${j.id}`} key={j.id} className="sticker block p-6"
                data-testid={`job-card-${j.id}`}>
                <div className="flex items-center justify-between mb-3">
                  <div className="chip">{j.job_number}</div>
                  <div className="chip chip-orange">{j.phase}</div>
                </div>
                <div className="font-display text-2xl leading-tight">{j.project_name}</div>
                <div className="text-sm text-[var(--gc-text-muted)] mt-1">{j.project_type}</div>
                <div className="mt-6">
                  <JobTimeline currentPhase={j.phase} />
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
